/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../../mrfiktiv-http-client.provider";
import {
  MrfiktivFleetEventControllerGetAllPostParamsGen,
  MrfiktivFleetEventControllerListParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen
} from "../../v1/data-contracts";
import { FleetEvents } from "../../v1/FleetEvents";

export class EventFleetService {
  proxy: FleetEvents;

  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.proxy = new FleetEvents(clientProvider.client());
  }

  async findAll(query: MrfiktivFleetEventControllerGetAllPostParamsGen, data: MrfiktivMultipleIdsDtoOptionalGen) {
    return (await this.proxy.fleetEventControllerGetAllPost(query, data)).data;
  }

  async list(query: MrfiktivFleetEventControllerListParamsGen) {
    return (await this.proxy.fleetEventControllerList(query)).data;
  }

  async findOverdue(partnerId: string, fleetId: string) {
    return (await this.proxy.fleetEventControllerOverdue(partnerId, fleetId)).data;
  }

  findOne(partnerId: string, fleetId: string, eventId: string) {
    return this.proxy.fleetEventControllerGetOne(partnerId, fleetId, eventId);
  }
}

export default new EventFleetService(new MrfiktivHttpClientProvider());
